import Commons from '../../../Services/Common/Common';

export const M_DCM_BASIC_01_Schema = {
  mapper: {
    /** SP_GET_AUTH_CUST_MANAGER 사업장 조회 */
    search1: {
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd),
      UserId: (context) => context.userInfo?.userid,
    },
    /** SP_GET_DEP_LAST 부서 조회 */
    search2: {
      CustCd: (context) => Commons.EncryptAES(context.custCd),
      SearchText: () => Commons.EncryptAES(''),
    },
    /** SP_GetTab 탭 조회 */
    search3: {
      UserId: (context) => context.userInfo?.userid,
    },
  },
};
